let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j82pJ")).then(() => parcelRequire('hfn9j'));